import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
import * as moment from 'moment';

export {
  IUpdateTravelPeriodDatesDraftVariables,
  RESET_TRAVEL_PERIOD,
  SHOW_DEALS,
  UNDO_TRAVEL_PERIOD_CHANGES,
  UPDATE_TRAVEL_PERIOD_DATES_DRAFT,
};

interface IUpdateTravelPeriodDatesDraftVariables {
  startDate: moment.Moment;
  endDate: moment.Moment;
}

const SHOW_DEALS: DocumentNode = gql`
  mutation showDeals {
    showDeals @client
  }
`;

const RESET_TRAVEL_PERIOD: DocumentNode = gql`
  mutation resetTravelPeriod {
    resetTravelPeriod @client
    undoFiltersChanges @client
    showDeals @client
  }
`;

const UNDO_TRAVEL_PERIOD_CHANGES: DocumentNode = gql`
  mutation undoTravelPeriodChanges {
    undoTravelPeriodChanges @client
  }
`;

const UPDATE_TRAVEL_PERIOD_DATES_DRAFT: DocumentNode = gql`
  mutation updateTravelPeriodDatesDraft($startDate: String, $endDate: String) {
    updateTravelPeriodDatesDraft(startDate: $startDate, endDate: $endDate) @client
  }
`;
